import { registerComponent } from '@gig/magic-common';
import LoyaltyCardComponent from './loyalty-card.vue.js';

var LoyaltyCard = registerComponent(LoyaltyCardComponent);

export { LoyaltyCard };
